import { render } from "./associationAdministrator.vue?vue&type=template&id=54ae4d40&scoped=true"
import script from "./associationAdministrator.vue?vue&type=script&lang=js"
export * from "./associationAdministrator.vue?vue&type=script&lang=js"

import "./associationAdministrator.vue?vue&type=style&index=0&id=54ae4d40&lang=scss&scoped=true"
import "./associationAdministrator.vue?vue&type=style&index=1&id=54ae4d40&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ae4d40"]])

export default __exports__